import type { ReactNode } from "react";

import whiteBFCLogo from "@bfc-software/bfc-web-ui/assets/bfc-main-white.svg";

import styles from "./branded-screen.module.css";

interface BrandedScreenProps {
  /**
   * How prominent the logo is. Signing in leads with the brand; the product
   * picker leads with the products, so its logo steps back.
   */
  logo?: "lead" | "supporting";
  children: ReactNode;
}

/**
 * The full-bleed navy treatment used for screens that sit outside the app
 * proper - signing in, and choosing a product.
 *
 * These are thresholds rather than pages: they carry no app header, no
 * navigation and no warehouse. Sharing the treatment is what makes the product
 * picker read as the last step of getting in rather than the first screen of
 * some tool.
 *
 * Signing in and choosing a product both use this, which is what makes them
 * read as one sequence rather than two unrelated screens.
 */
export function BrandedScreen({
  logo = "supporting",
  children,
}: BrandedScreenProps) {
  // A div, not a <main>: the organisation layout already renders AppContainer,
  // which is one.
  return (
    <div className={styles.screen}>
      <div className={styles.pattern} aria-hidden="true" />
      <div className={styles.content}>
        <img
          className={styles.logo}
          data-logo={logo}
          src={whiteBFCLogo}
          alt="BFC Software"
        />
        {children}
      </div>
    </div>
  );
}
